<template>
  <div class="tip-div">
    <Poptip word-wrap :width=width :content=content trigger="hover" placement="right">
      <Icon type="ios-alert-outline" size="14"/>
    </Poptip>
  </div>
</template>

<script>
export default {
  name: 'InfoPopTip',
  props: {
    content: {
      type: String,
      default: ''
    },
    /**
     * @description 起始值，即动画开始前显示的数值
     */
    width: {
      type: Number,
      default: 200
    }
  }
}
</script>
<style scoped>
.tip-div{
  display:inline;
  font-size: 10px;
  font-weight:normal;
}
</style>
